import { format as dateFnsFormat } from 'date-fns';
import { OptionsWithTZ, utcToZonedTime } from 'date-fns-tz';
import { toTimezoneAndFormat } from './Date';

export interface ITimezonePreferenceStore {
    timezone: string | undefined;
}

export interface ITimezoneStore {
    timezones: Map<string, string | undefined>;
}

let timezonePreferenceStore: ITimezonePreferenceStore | undefined;
export function registerTimezonePreferenceStore(store: ITimezonePreferenceStore) {
    timezonePreferenceStore = store;
}

let timezoneStore: ITimezoneStore | undefined;
export function registerTimezoneStore(store: ITimezoneStore) {
    timezoneStore = store;
}

export function displayFormatTime(date: Date, format: string, displaySerialNumber: string, options?: OptionsWithTZ) {
    if (format.indexOf('ZZZZ') >= 0) format = format.replace('ZZZZ', `'${getTimezone(displaySerialNumber)}'`);

    switch (timezonePreferenceStore?.timezone) {
        default:
        case 'unit-time':
            return toTimezoneAndFormat(
                date,
                format,
                timezoneStore?.timezones.get(displaySerialNumber) ?? 'UTC',
                options
            );
        case 'utc':
            return toTimezoneAndFormat(date, format, 'UTC', options);
        case 'user-time':
            return dateFnsFormat(date, format, options);
    }
}

export function getTimezone(displaySerialNumber: string) {
    switch (timezonePreferenceStore?.timezone) {
        default:
        case 'unit-time':
            return timezoneStore?.timezones.get(displaySerialNumber) ?? 'UTC';
        case 'utc':
            return 'UTC';
        case 'user-time':
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
}

export function displayUtcToZonedTimeFactory(
    displaySerialNumber: string
): (date: Date, options?: OptionsWithTZ) => Date {
    switch (timezonePreferenceStore?.timezone) {
        default:
        case 'unit-time':
            const timezone = timezoneStore?.timezones.get(displaySerialNumber) ?? 'UTC';
            return (date: Date, options?: OptionsWithTZ) => utcToZonedTime(date, timezone, options);
        case 'utc':
            return (date: Date, options?: OptionsWithTZ) => utcToZonedTime(date, 'UTC', options);
        case 'user-time':
            return (date: Date, options?: OptionsWithTZ) => date;
    }
}
